module.exports = __webpack_public_path__ + "img/nuvola_4.d6f8ba82.png";